import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { InfoCircle } from "react-bootstrap-icons";

interface IImagePopoverProps {
  img: string;
  className?: string;
}
export default function ImagePopover({ img, className }: IImagePopoverProps) {
  return (
    <OverlayTrigger
      trigger={["hover", "focus"]}
      placement="right"
      overlay={
        <Popover>
          <Popover.Body>
            <img src={img} alt="" className="img-fluid" />
          </Popover.Body>
        </Popover>
      }
    >
      <InfoCircle className={className} />
    </OverlayTrigger>
  );
}
